import { createElement, memo } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Image from '@max/leez-image';
import './index.scss';
import { PRICE_REDUCTION_BG } from '../../const';
const PriceDisplay = (props) => {
    const { currentPrice, originalPrice, priceLabel, isRecommended = true, currencySymbol = '¥', mode = 'horizontal', className = '', handleNavigate } = props;
    const hasOriginalPrice = originalPrice && originalPrice > currentPrice;
    return <>
      {true ? <View className="hotel-card__recommended-container">
          <Image source={{
                uri: PRICE_REDUCTION_BG
            }} className="hotel-card__price-image" style={{
                width: '320rpx',
                position: 'relative',
                top: '20rpx',
                overflow: 'visible'
            }}>
            <View className="hotel-card__price-row">
              <View className="hotel-card__price-change-container">
                <View>
                  {originalPrice && <Text className="hotel-card__original-price-comparision">
                      ¥{originalPrice}
                    </Text>}
                </View>
                <View className="hotel-card__price-container hotel-card__recommended-price-container">
                  <Text className="hotel-card__price-symbol">¥</Text>
                  <Text className="hotel-card__current-price">{currentPrice}</Text>
                </View>
              </View>
            </View>
          </Image>
          <View className="hotel-card__book-btn" onClick={handleNavigate}>
            <Text className="hotel-card__book-text">抢购</Text>
          </View>
        </View> : <View className="hotel-card__price-row">
          <View>
            <View className="hotel-card__price-container">
              <Text className="hotel-card__price-symbol">¥</Text>
              <Text className="hotel-card__current-price">{currentPrice}</Text>
              {/* {priceLabel && <Text className="hotel-card__price-label">{priceLabel}</Text>} */}
              {originalPrice && <Text className="hotel-card__original-price">¥{originalPrice}</Text>}
            </View>
          </View>

          <View className="hotel-card__book-btn" onClick={handleNavigate}>
            <Text className="hotel-card__book-text">抢购</Text>
          </View>
        </View>}
      {/* <View className="hotel-card__price-row">
            <View>
              <View className="hotel-card__price-container">
                <Text className="hotel-card__price-symbol">¥</Text>
                <Text className="hotel-card__current-price">{currentPrice}</Text>
                {priceLabel && <Text className="hotel-card__price-label">{priceLabel}</Text>}
                {originalPrice && originalPrice > currentPrice && (
                  <Text className="hotel-card__original-price">¥{originalPrice}</Text>
                )}
              </View>
            </View>
             <View className="hotel-card__book-btn">
              <Text className="hotel-card__book-text">抢购</Text>
            </View>
          </View> */}
    </>;
};
export default memo(PriceDisplay);
